import { ReactComponent as CloseDialog } from 'assett/icons/close_dialog_icon.svg';
import { onChangeClaim, submitClaim } from 'feature/claims/claimSlice';
import useDialogSubmitClaim from 'hooks/DialogSubmitClaim.hook';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import {
	Box,
	Button,
	Dialog,
	IconButton,
	Stack,
	TextField,
	Typography,
} from 'styles';
import { CLAIM_NOTE_MAX_LENGTH } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const DialogSubmitClaim = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const submitClaimDialog = useDialogSubmitClaim();
	const { open, externalClaimId } = useSelector(
		(store: RootState) => store.hooks.submitClaim,
	);
	const { claimData: formData } = useSelector((state: RootState) => state.claim);
	const [note, setNote] = useState('');

	const handleClick = () => {
		dispatch(submitClaim(formData)).finally(() => {
			handleClose();
		});
	};

	const handleClose = () => {
		dispatch(onChangeClaim(() => ({ ...formData, internalNote: '' })));
		setNote('');
		submitClaimDialog.close();
	};

	const handleChange = (note: string) => {
		dispatch(onChangeClaim(() => ({ ...formData, internalNote: note })));
		setNote(note);
	};

	return (
		<Dialog
			type={''}
			open={open}
			variant={'deleteClaimDialog'}
			title={tClientLabels('dialog.submitClaim.title')}
			events={false}
			close={
				<IconButton disableRipple onClick={handleClose}>
					<CloseDialog />
				</IconButton>
			}
			actions={<></>}
			PaperProps={{
				sx: {
					width: {
						sm: '450px !important',
					},
					minWidth: {
						sm: '450px !important',
					},
				},
			}}
		>
			<Stack
				height={{
					sm: '366px',
					md: '390px',
				}}
				justifyContent={'space-between'}
			>
				<Stack
					gap={{
						sm: '30px',
						md: '40px',
					}}
				>
					<Box>
						<Typography variant="body">
							{tClientLabels('dialog.submitClaim.content', {
								claim_number: externalClaimId,
							})}
						</Typography>
					</Box>
					<TextField
						name="feedback"
						type="text"
						label={tClientLabels('commons.textFieldHeader.feedback')}
						sx={{
							height: 'fit-content',

							'.MuiFormHelperText-root': {
								margin: '8px 16px !important',
							},
						}}
						multiline
						inputProps={{ maxLength: CLAIM_NOTE_MAX_LENGTH }}
						onChange={e => handleChange(e.target.value)}
						autoComplete={'off'}
						helperText={
							<Typography variant="caption" color={theme => theme.palette.grey2.main}>
								{note.length}/{CLAIM_NOTE_MAX_LENGTH}
							</Typography>
						}
					/>
				</Stack>
				<Stack
					direction={'row'}
					gap={{
						sm: '16px',
						md: '20px',
					}}
					justifyContent={'flex-end'}
				>
					<Button
						variant="contained"
						onClick={handleClick}
						sx={{
							justifyContent: 'center',
						}}
						disabled={!note}
					>
						{tClientLabels('dialog.updateClaim.confirm')}
					</Button>
				</Stack>
			</Stack>
		</Dialog>
	);
};

export default DialogSubmitClaim;
